// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"eP","backToTop":"eP"};